import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPersonAdd = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M6 7a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M1 14v-2.5A2.5 2.5 0 0 1 3.5 9h5A2.5 2.5 0 0 1 11 11.5V14z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M12.25 4.25V5.5h1.5V4.25H15v-1.5h-1.25V1.5h-1.5v1.25H11v1.5z"
		})
	]
});
export default SvgPersonAdd;
